/* Mominti — één productkaartje per kleur in productlijsten (v1 2026-10-22)
   Bestand: assets/mominti-kleurkaarten.js, geladen in layout/theme.liquid.
   Werking: voor elk productkaartje met kleur-swatches wordt per extra kleur een kopie van het kaartje
   ingevoegd en wordt in die kopie de swatch van die kleur gekozen. Het thema (Horizon) werkt dan zelf de foto,
   de link (?variant=…) en de swatch bij — het kaartje is dus het echte themakaartje. */
(function () {
  var SUFFIX = 0;

  function uniqueIds(root) {
    var tag = '-mmc' + (++SUFFIX);
    var map = {};
    root.querySelectorAll('[id]').forEach(function (el) { var n = el.id + tag; map[el.id] = n; el.id = n; });
    ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var v = el.getAttribute(attr).split(' ').map(function (id) { return map[id] || id; }).join(' ');
        el.setAttribute(attr, v);
      });
    });
    root.querySelectorAll('input[type="radio"]').forEach(function (i) { i.name = i.name + tag; });
  }

  // Kies de kleur in de kopie zodra de themacomponenten klaar zijn; opnieuw tot de link naar die kleur wijst
  function selectColor(sourceCard, clone, target) {
    var srcLink = (sourceCard.querySelector('a') || {}).href;
    var tags = ['product-card', 'swatches-variant-picker-component', 'product-swatches'];
    var ready = Promise.all(tags.map(function (t) {
      return Promise.race([customElements.whenDefined(t), new Promise(function (r) { setTimeout(r, 3000); })]);
    }));
    ready.then(function () {
      var tries = 0;
      (function attempt() {
        var card = clone.querySelector('product-card');
        var link = card && card.querySelector('a');
        var input = clone.querySelectorAll('product-swatches input[type="radio"]')[target._mmIdx] || target;
        // Klaar als de swatch gekozen is én het thema de link op ?variant= van deze kleur heeft gezet
        if (input.checked && link && link.href !== srcLink && link.href.indexOf('variant=') !== -1) { clone.style.opacity = ''; return; }
        if (tries++ > 8) { clone.style.opacity = ''; return; }
        // De swatch staat vooraf al visueel aan; voor het thema-event even uitzetten en echt klikken (één keer)
        if (!input._mmClicked) { input._mmClicked = true; input.checked = false; input.click(); }
        else if (!input.checked) input.click();
        setTimeout(attempt, 400);
      })();
    });
  }

  function expand(card) {
    var item = card.closest('.resource-list__item, .product-grid__item, li') || card;
    if (item.hasAttribute('data-mm-color-card') || item.hasAttribute('data-mm-color-source')) return;
    var radios = Array.prototype.slice.call(card.querySelectorAll('product-swatches input[type="radio"]'));
    if (radios.length < 2) return;
    item.setAttribute('data-mm-color-source', '');
    var current = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    // Toon ook op het eerste kaartje welke kleur het is (alleen visueel; zet geen change-event af)
    current.checked = true;
    var anchor = item;
    radios.forEach(function (radio, idx) {
      if (radio === current || radio.disabled) return;
      var clone = item.cloneNode(true);
      // cloneNode neemt geen (declaratieve) shadow DOM mee, bv. van <overflow-list> met de swatches
      var srcEls = item.querySelectorAll('*'), dstEls = clone.querySelectorAll('*');
      for (var k = 0; k < srcEls.length; k++) {
        if (srcEls[k].shadowRoot && dstEls[k] && !dstEls[k].shadowRoot) {
          try { dstEls[k].attachShadow({ mode: 'open' }).innerHTML = srcEls[k].shadowRoot.innerHTML; } catch (e) {}
        }
      }
      // Toon meteen de foto van deze kleur: zet de variantfoto vooraan en zichtbaar vóór het invoegen
      // (de slideshow leest zijn slides pas bij het verbinden), zodat er geen vertraging/flits is.
      var mediaId = radio.getAttribute('data-option-media-id');
      var slide = mediaId && clone.querySelector('slideshow-slide[slide-id="' + mediaId + '"]');
      if (slide) {
        var first = slide.parentNode.querySelector('slideshow-slide');
        if (first && first !== slide) {
          first.setAttribute('hidden', '');
          first.setAttribute('aria-hidden', 'true');
          slide.parentNode.insertBefore(slide, first);
        }
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'false');
        slide.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      }
      // Link meteen naar deze kleur laten wijzen (Shopify kiest de variant via ?option_values=); het thema
      // vervangt dit daarna door ?variant=…
      var valueId = radio.getAttribute('data-option-value-id');
      if (valueId) {
        clone.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          var u = new URL(a.href, location.origin);
          u.searchParams.delete('variant');
          u.searchParams.set('option_values', valueId);
          a.href = u.pathname + u.search;
        });
      }
      clone.removeAttribute('data-mm-color-source');
      clone.setAttribute('data-mm-color-card', radio.value);
      uniqueIds(clone);
      anchor.after(clone);
      anchor = clone;
      var target = clone.querySelectorAll('product-swatches input[type="radio"]')[idx];
      if (target) { target._mmIdx = idx; target.checked = true; } // meteen de juiste kleur-swatch tonen
      // Thema laten bijwerken (link ?variant=, swatch-status); alleen verbergen als we de foto niet vooraf konden zetten
      if (!slide) { clone.style.opacity = '0'; clone.style.transition = 'opacity .3s ease'; }
      if (target) selectColor(card, clone, target);
      else clone.style.opacity = '';
    });
  }

  function run(scope) {
    (scope || document).querySelectorAll('.resource-list product-card, .product-grid product-card').forEach(expand);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  // Theme editor: sectie opnieuw gerenderd
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  // Lijsten die opnieuw renderen (filters/sorteren op collectiepagina's)
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
